<template>
  <div class="admin-settings-page">

    <div class="page-header">
      <div>
        <h1>System Settings</h1>
        <p>Manage payment gateway and AI configuration.</p>
      </div>
    </div>

    <div class="settings-grid">

      <!-- STRIPE -->
      <div class="settings-card">
        <h3>Stripe Payment Gateway</h3>

        <div class="form-group" style="margin-top: 2rem;">
          <label>Stripe Publishable Key</label>
          <input v-model="settings.stripe_publishable_key" />
        </div>

        <div class="form-group">
          <label>Stripe Secret Key</label>
          <input v-model="settings.stripe_secret_key" />
        </div>

        <button class="primary-btn save-btn" style="margin-top: 1rem;" @click="saveSettings">
          Save Settings
        </button>

      </div>

      <!-- CHATGPT -->
      <div class="settings-card">
        <h3>ChatGPT API</h3>

        <div class="form-group" style="margin-top: 2rem;">
          <label>OpenAI API Key</label>
          <input v-model="settings.openai_api_key" />
        </div>

        <button class="primary-btn save-btn" style="margin-top: 1rem;" @click="saveSettings">
          Save Settings
        </button>

      </div>

      <!-- CHANGE PASSWORD -->
     

    </div>
 <div class="settings-card">
        <h3>Change Password</h3>

        <div class="form-group" style="margin-top: 2rem;">
          <label>Current Password</label>
          <input type="password" v-model="password.current" />
        </div>

        <div class="form-group">
          <label>New Password</label>
          <input type="password" v-model="password.new" />
        </div>

        <div class="form-group">
          <label>Confirm Password</label>
          <input type="password" v-model="password.confirm" />
        </div>

        <button class="primary-btn" style="padding-left: 2rem; padding-right: 2rem; margin-top: 1rem;" @click="changePassword">
          Update Password
        </button>

      </div>
    

  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import { saveAdminSettings, getAdminSettings } from "@/apis/settingsapis";
import { changePassword } from "@/apis/userapis";


export default {

  name: "AdminSettings",

  data() {
    return {
      toast: null,
      admin_id: "",

      settings: {
        stripe_publishable_key: "",
        stripe_secret_key: "",
        openai_api_key: ""
      },

      password: {
        current: "",
        new: "",
        confirm: ""
      }

    };
  },

  async mounted() {

    this.toast = useToast();

    const tmp = sessionStorage.getItem("ldata") || "";

    if (tmp && tmp.length > 0) {
      const ldata = JSON.parse(tmp);
      this.admin_id = ldata.user_id;
    }

    this.loadSettings();

  },

  methods: {

    async loadSettings() {

      const res = await getAdminSettings(this.admin_id);

      if (res.status && res.data?.admin_set_data1) {

        try {
          this.settings = JSON.parse(res.data.admin_set_data1);
        } catch {
          console.warn("Settings JSON parse failed");
        }

      }

    },

    async saveSettings() {

      const json = JSON.stringify(this.settings);

      const res = await saveAdminSettings(
        json,
        "",
        this.admin_id
      );

      if (res.status) {
        this.toast.success("Settings saved successfully");
      } else {
        this.toast.error("Failed to save settings");
      }

    },

    async changePassword() {

      if (!this.password.current || !this.password.new) {
        this.toast.error("Please fill all fields");
        return;
      }

      if (this.password.new !== this.password.confirm) {
        this.toast.error("Passwords do not match");
        return;
      }

      try {

        const res = await changePassword(
        this.admin_id,
        this.password.current,
        this.password.new
      );

      if (res.status) {
        this.toast.success("Password updated successfully");

        this.password.current = "";
        this.password.new = "";
        this.password.confirm = "";
      } else {
        this.toast.error("Failed to change password");
      }

        

      } catch (e) {

        this.toast.error("Failed to update password");

      }

    }

  }

};
</script>

<style scoped>

.admin-settings-page {
  padding: 28px;
  background: #f6f7f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.page-header h1 {
  font-size: 28px;
  font-weight: 800;
}

.page-header p {
  font-size: 14px;
  color: #64748b;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(360px,1fr));
  gap: 14px;
}

.settings-card {
  background: white;
  border-radius: 18px;
  padding: 22px;
  border: 1px solid #e2e8f0;
}

.settings-card h3 {
  margin-bottom: 14px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
}

.form-group label {
  font-size: 12px;
  font-weight: 600;
}

.form-group input {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
}

.primary-btn {
  height: 42px;
  background: #197fe6;
  border-radius: 12px;
  border: none;
  color: white;
  font-weight: 700;
  cursor: pointer;
}

.save-btn {
  width: 220px;
}

</style>